import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

// axios default configuration
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
Vue.axios.defaults.headers.post["Content-Type"] = "application/json";
